import React from 'react';
import './hosLogBanner.scss';

interface Props {
  text: string;
  count: number;
  buttonText?: string;
  onClick: () => void;
}
export const LogBanner: React.FC<Props> = ({ count, text, buttonText = 'View Logs', onClick }) => {
  return (
    <div className={`log-banner${count === 0 ? '__empty' : ''}`}>
      <div className="log-banner-title">
        <h4>{count}</h4>
        <h5>{text}</h5>
      </div>
      {count > 0 && <button onClick={onClick}>{buttonText}</button>}
    </div>
  );
};
